export var ACTION;
(function (ACTION) {
    ACTION["PAYMENT_DASHBOARD"] = "PAYMENT_DASHBOARD";
    ACTION["EDIT_AMOUNT"] = "EDIT_AMOUNT";
    ACTION["CHECKBOX_HANDLE"] = "CHECKBOX_HANDLE";
    ACTION["ON_PAGE_LOAD"] = "ON_PAGE_LOAD";
    ACTION["BLANK_ACTION"] = "BLANK_ACTION";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["ACTION"] = "REMOVE_WEBVIEW";
    ACTION["RESET_PAGE"] = "RESET_PAGE";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["PRE_FILL_PARTIAL_AMOUNT"] = "PRE_FILL_PARTIAL_AMOUNT";
    ACTION["ERROR_INSTRUMENT"] = "ERROR_INSTRUMENT";
    ACTION["NAVIGATE_TO_SUMMARY_SCREEN"] = "NAVIGATE_TO_SUMMARY_SCREEN";
    ACTION["GO_BACK_ACTION"] = "GO_BACK_ACTION";
    ACTION["TRACK_PAYMENT_SELECTION"] = "TRACK_PAYMENT_SELECTION";
})(ACTION || (ACTION = {}));
